import { RouteObject } from "react-router"
import CanalDistShell from "./view/canalDist.shell"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { DeliveryDining, Payments } from "@mui/icons-material"

export enum PathRotaCanalDist {
    canalDist = "/canaldist"
}

const routerCanalDist: RouteObject = {
    path: PathRotaCanalDist.canalDist,
    element: <CanalDistShell readViewOnShow={true}/>,
}


export const navigationToCanalDistView = ()=> rotas.navigate(PathRotaCanalDist.canalDist)

export function startRouterCanalDist(){
    const menu:MainMenu = {
        text:"Canais de Distribuição",
        icon:<DeliveryDining />,
        eventOnClick:navigationToCanalDistView
    }
    menuRotas.push(menu);
    return routerCanalDist
}